import React from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import useReveal from '../../AIEmployees/useReveal';
import '../../AIEmployees/sections/AIEClose.css';

/**
 * SAClose — the final CTA beat for /super-agents. This page previously reused
 * AIEClose ("Hire your first AI employee"), which told the wrong product story
 * on a super-agent page (Nitish, Aug 4). Same visual system (.aie-close
 * classes), its own super-agent words.
 */
const SAClose = ({ ctaLabel, onPrimary }) => {
  const [ref, visible] = useReveal();

  return (
    <section className="aie-close" ref={ref}>
      <div className="aie-close__glow" aria-hidden="true" />
      <div className={`aie-close__inner aie-reveal ${visible ? 'is-visible' : ''}`}>
        <h2 className="aie-close__title aie-display">
          One agent. The whole job. Done.
        </h2>
        <p className="aie-close__sub">
          Give it the task and get the finished artifact back: research, code,
          video, documents, dashboards. Start with 200 free credits.
        </p>
        <button
          type="button"
          data-msc-suppress
          className="aie-btn aie-btn-primary aie-close__cta"
          onClick={onPrimary}
        >
          {ctaLabel}
          <ArrowRightOutlined />
        </button>
      </div>
    </section>
  );
};

export default SAClose;
